import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { request } from '@cvt/clients/baseClient';
import { Dialog, DialogContent, Stack, Typography } from '@mui/material';
import HeartPulse from '@modules/Tributes/components/HeartPulse';
const apiBaseUrl = import.meta.env.VITE__CVT_API_URL as string;

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSession = async () => {
      if (!sessionId) return;
      try {
        const options = {
          url: `${apiBaseUrl}/checkout-sessions/${sessionId}/`,
          method: 'GET',
        };
        const res = await request({ options });

        if (res.data.status === 'completed') {
          navigate(`${res.data.metadata.fe_redirection}`, { replace: true });
        } else {
          setError('Payment not completed yet. Please wait or contact support.');
        }
      } catch (error) {
        console.error('Error fetching session:', error);
        setError('An error occurred while processing your payment.');
      }
    };

    fetchSession();
  }, [sessionId, navigate]);

  if (error) {
    return (
      <Dialog open={true} PaperProps={{ variant: 'elevation' }}>
        <DialogContent>
          <Stack p={{ xs: 4, sm: 8 }} gap={2}>
            <Typography variant="h1" fontSize={24} align="center" mb={2}>
                        There was an Error Processing Your Payment ...
            </Typography>
            <HeartPulse />
          </Stack>
        </DialogContent>
      </Dialog>
    );
  }
  return (
    <Dialog open={true} PaperProps={{ variant: 'elevation' }}>
      <DialogContent>
        <Stack p={{ xs: 4, sm: 8 }} gap={2}>
          <Typography variant="h1" fontSize={24} align="center" mb={2}>
                      Processing Payment ...
          </Typography>
          <HeartPulse />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
